import { rewriteImageSrc } from '@/utils/rewriteImageSrc';

import { publicationDetailsContainer } from './PublicationDetails.css';

type PublicationDetailsProps = {
  publicationName: string;
  publicationDescription: string;
  publicationLogoURL: string;
};

export const PublicationDetails = ({
  publicationName,
  publicationDescription,
  publicationLogoURL,
}: PublicationDetailsProps) => {
  return (
    <div className={publicationDetailsContainer}>
      <div
        className="flex items-center gap-x-2 py-4"
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <img
          src={rewriteImageSrc(publicationLogoURL)}
          alt={publicationDescription}
          width={40}
          height={40}
          className="overflow-hidden"
        />
        <p>{publicationName}</p>

        {/* <Typography
          as="p"
          size="md"
          weight="semibold"
          color={webTheme?.footer_text_color}
          fontFamilyv2={webTheme?.font_body}
        >
          {publicationName}
        </Typography> */}
      </div>
      <div className="text-center sm:text-left">
        <p className="text-sm">{publicationDescription}</p>
        {/* <Typography
          as="p"
          size="sm"
          weight="regular"
          color={webTheme?.footer_text_color}
          fontFamilyv2={webTheme?.font_body}
        >
          {publicationDescription}
        </Typography> */}
      </div>
    </div>
  );
};
